export default function truncate(text: string | undefined, max: number, truncateChar: string = '...') {
  if (typeof text === 'undefined') {
    return undefined
  }

  if (text!.length <= max) {
    return text
  }

  return text!.slice(0, max - truncateChar.length) + truncateChar
}
